var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fily;
(function (Fily) {
    var DuplicateSubmitGuard = (function (_super) {
        __extends(DuplicateSubmitGuard, _super);
        function DuplicateSubmitGuard() {
            var _this = _super.call(this, { delegate: false }) || this;
            _this.delegateEvent();
            return _this;
        }
        DuplicateSubmitGuard.prototype.events = function () {
            return {
                "submit / .js-duplicate-submit-guard-form": "setDisabled",
                "unsetDisabled / .js-duplicate-submit-guard-form": "unsetDisabled",
            };
        };
        DuplicateSubmitGuard.prototype.setDisabled = function (event) {
            var $form = $(event.currentTarget);
            var $submit = $form.find(":submit");
            $form.prop("disabled", true);
            $submit.prop("disabled", true);
            setTimeout(function () {
                $form.prop("disabled", false);
                $submit.prop("disabled", false);
            }, 8000);
        };
        DuplicateSubmitGuard.prototype.unsetDisabled = function (event) {
            var $form = $(event.currentTarget);
            var $submit = $form.find(":submit");
            setTimeout(function () {
                $form.prop("disabled", false);
                $submit.prop("disabled", false);
            }, 1000);
        };
        return DuplicateSubmitGuard;
    }(Fily.BaseView));
    Fily.DuplicateSubmitGuard = DuplicateSubmitGuard;
})(Fily || (Fily = {}));
